import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';

class VehicleData extends Component {
  render() {
    const {selectedVehicle} = this.props;
    return (
      <Grid.Row>
        <Grid.Column width={1}>
          <h4>Sfx:</h4>
        </Grid.Column>
        <Grid.Column width={1}>
          {selectedVehicle.sfx}
        </Grid.Column>
        <Grid.Column width={2}>
          <h4>Nombre Comercial:</h4>
        </Grid.Column>
        <Grid.Column width={3}>
          {selectedVehicle.commercialName}
        </Grid.Column>
        <Grid.Column width={2}>
          <h4>Descripción:</h4>
        </Grid.Column>
        <Grid.Column width={3}>
          {selectedVehicle.description}
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default VehicleData;
